import { SIDE_MENU_KEY } from '@/constants';

export default {
  namespaced: true,
  state: {
    menuItems: [
      {
        visible: false,
        isCollapsed: true,
        name: 'Accounts',
        items: [{
          url: '/payments',
          text: 'Payments',
          iconUrl: require('@/assets/images/menu-icons/icons_payments_blue.svg'),
          routeName: 'payments'
        },
          {
            url: '/partners-balances',
            text: 'Partners balances',
            iconUrl: require('../../assets/images/menu-icons/partners_balances.svg'),
            routeName: 'partners-balances'
          }
        ]
      },
      {
        visible: false,
        isCollapsed: true,
        name: 'Purchases',
        items: [{
          url: '/contracts',
          text: 'Contracts',
          iconUrl: require('@/assets/images/menu-icons/icons_contracts_blue.svg'),
          routeName: 'purchase_contracts'
        },
          {
            url: '/lots',
            text: 'LotsAndSpecifications',
            iconUrl: require('@/assets/images/menu-icons/icons_payments_blue.svg'),
            routeName: 'purchase_lots'
          },
          {
            url: '/purchaseOrders',
            text: 'PurchaseOrders',
            iconUrl: require('@/assets/images/menu-icons/icons_purchases_blue.svg'),
            routeName: 'purchase_orders'
          },
          {
            url: '/purchaseOrderItems',
            text: 'PurchaseOrderItems',
            iconUrl: require('@/assets/images/menu-icons/icons_order-items.svg'),
            routeName: 'purchase_order_items'
          },
          {
            url: '/requests',
            text: 'Requests',
            iconUrl: require('@/assets/images/menu-icons/icons_request_blue.svg'),
            routeName: 'special_orders'
          },
          {
            url: '/binding',
            text: 'Packages_binding',
            iconUrl: require('@/assets/images/menu-icons/icons_packages_binding.svg'),
            routeName: 'packages_binding'
          },
          {
            url: '/purchase-invoices',
            text: 'Invoices',
            iconUrl: require('@/assets/images/menu-icons/purchase_invoices.svg'),
            routeName: 'purchase_invoices'
          }
        ]
      },
      {
        visible: false,
        isCollapsed: true,
        name: 'Sales',
        items: [
          {
            url: '/sales-contracts',
            text: 'Contracts',
            iconUrl: require('@/assets/images/menu-icons/icons_contracts_blue.svg'),
            routeName: 'sale_contracts'
          },
          {
            url: '/fixed-margin',
            text: 'Fixed Margin',
            iconUrl: require('@/assets/images/menu-icons/icons_fixed_margin_blue.svg'),
            routeName: 'fixed_margin'
          },
          {
            url: '/payments-invoices',
            text: 'Payments And Invoices',
            iconUrl: require('@/assets/images/menu-icons/icons_payments_and_invoices_blue.svg'),
            routeName: 'payments_and_invoices'
          },
          {
            url: '/sales-orders',
            text: 'SalesOrders',
            iconUrl: require('@/assets/images/menu-icons/icons_purchases_blue.svg'),
            routeName: 'sale_orders'
          },
          {
            url: '/sales-invoices',
            text: 'Invoices',
            iconUrl: require('@/assets/images/menu-icons/purchase_invoices.svg'),
            routeName: 'invoices'
          }
        ]
      },
      {
        isCollapsed: true,
        name: 'General',
        items: [
          {
            url: '/partners',
            text: 'Partners',
            iconUrl: require('@/assets/images/menu-icons/icons_partners_blue.svg'),
            routeName: 'partners'
          },
          {
            url: '/products',
            text: 'Products',
            iconUrl: require('@/assets/images/menu-icons/icons_contracts_blue.svg'),
            routeName: 'products_search'
          },
          {
            url: '/price-policy',
            text: 'Price policy',
            iconUrl: require('@/assets/images/menu-icons/price_pocily.svg'),
            routeName: 'price_policy'
          },
          {
            url: '/documents',
            text: 'Documents',
            iconUrl: require('@/assets/images/menu-icons/icons_documents_blue.png'),
            routeName: 'documents'
          },
          {
            url: '/documents-storage',
            text: 'Documents storage',
            iconUrl: require('@/assets/images/menu-icons/icons_documents_blue.png'),
            routeName: 'documents-storage'
          },
          {
            url: '/admin',
            text: 'Settings',
            iconUrl: require('@/assets/images/menu-icons/icons_settings_blue.svg'),
            routeName: 'settings'
          }
        ]
      },
      {
        isCollapsed: true,
        name: 'Manufacture',
        items: [
          {
            url: '/operations',
            text: 'Operations',
            iconUrl: require('@/assets/images/menu-icons/operations_search.svg'),
            routeName: 'operations'
          },
          {
            url: '/packets-search',
            text: 'Packets search',
            iconUrl: require('@/assets/images/menu-icons/packets_search.svg'),
            routeName: 'packets_search'
          },
          {
            url: '/reports',
            text: 'Reports',
            iconUrl: require('@/assets/images/menu-icons/reports.svg'),
            routeName: 'reports'
          }
        ]
      },
      {
        visible: false,
        isCollapsed: true,
        name: 'Production Planning',
        items: [
          {
            url: '/raw-distribution',
            text: 'RawDistribution',
            iconUrl: require('@/assets/images/menu-icons/icons_raw_distribution_blue.svg'),
            routeName: 'raw_distribution'
          },
          {
            url: '/order-products',
            text: 'Order Products',
            iconUrl: require('@/assets/images/menu-icons/icons_contracts_blue.svg'),
            routeName: 'order_products'
          }
        ]
      },
      {
        visible: false,
        isCollapsed: true,
        name: 'AgentsFees',
        items: [
          {
            url: '/sales-agent-invoices',
            text: 'AgentInvoices',
            iconUrl: require('@/assets/images/menu-icons/icons_sales_agent_invoices_blue.svg'),
            routeName: 'sale_agent_invoices'
          },
          {
            url: '/sales-commission-fees',
            text: 'SalesCommissionFees',
            iconUrl: require('@/assets/images/menu-icons/icons_comission_fees_blue.svg'),
            routeName: 'sale_agent_comissions_fees'
          },
          {
            url: '/purchase-commission-fees',
            text: 'PurchaseCommissionFees',
            iconUrl: require('@/assets/images/menu-icons/icons_comission_fees_blue.svg'),
            routeName: 'purchase_agent_comissions_fees'
          }
        ]
      }]
  },
  mutations: {
    menuCollapse(state, index) {
      state.menuItems[index]['isCollapsed'] = !state.menuItems[index]['isCollapsed'];
    },
    setVisibleMenuItems(state, permissions) {
      const menuItemsFromLocalStorage = localStorage.getItem(SIDE_MENU_KEY);
      menuItemsFromLocalStorage && (state.menuItems = JSON.parse(menuItemsFromLocalStorage));
      state.menuItems = state.menuItems.map(parentMenuItem => {
        parentMenuItem.show = false;
        parentMenuItem.items = parentMenuItem.items.map(menuItem => {
          const permissionRoute = permissions[menuItem.routeName];
          if (permissionRoute && permissionRoute.view) {
            parentMenuItem.show = true;
            menuItem.show = true;
          } else {
            menuItem.show = false;
          }
          return menuItem;
        });
        return parentMenuItem;
      });
    }
  },
  actions: {
    menuCollapse({commit, state}, payload) {
      commit('menuCollapse', payload);
      localStorage.setItem(SIDE_MENU_KEY, JSON.stringify(state.menuItems));
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/menu.js